(() => {
    const interval = setInterval(() => {
        const host = document.querySelector('form-embed#app-embed');
        
        if (host && host.shadowRoot) {
            const styleElement = document.querySelector('#b2b-registration');

            if (styleElement && styleElement.sheet) {
                const newSheet = new CSSStyleSheet();
                const cssRules = Array.from(styleElement.sheet.cssRules)
                                      .map(rule => rule.cssText)
                                      .join(' ');
                newSheet.replaceSync(cssRules);
                host.shadowRoot.adoptedStyleSheets.push(newSheet);
            }
            clearInterval( interval );
        }
    }, 50); 
})(); 